<script setup>
import { bookingStatusLabels } from '../api/mappers'

defineProps({ status: { type: String, required: true } })
</script>

<template>
  <span class="status-badge" :class="`status-badge--${status}`">
    <span class="status-dot" aria-hidden="true" />
    {{ bookingStatusLabels[status] || status }}
  </span>
</template>
